const READ = 'read';
const UPDATE = 'update';
const EXECUTE = 'execute';
const OWNER = 'owner';

const PERMISSIONS = [
  `user:${READ}`,
  `user:${UPDATE}`,

  `role:${READ}`,
  `role:${UPDATE}`,

  `connection:${READ}`,
  `connection:${UPDATE}`,

  `prompt-chain:${READ}`,
  `prompt-chain:${UPDATE}`,
  `prompt-chain:${EXECUTE}`,
  `prompt-chain:${OWNER}`,

  `api-user:${READ}`,
  `api-user:${UPDATE}`,

  `user-action-logs:${READ}`
] as const;

export { PERMISSIONS };
